import { AlertStatus } from '@/entities/alert-status';

export const AlertStatusFromValue: Record<number, AlertStatus> = {
  5: AlertStatus.CRITICAL,
  // 3: AlertStatus.TRIPPED,  // TODO: what to do here? no backwards mapping possible
  3: AlertStatus.WARNING,
  2: AlertStatus.INFO, // This is a temp because we do not have `concern` yet
  1: AlertStatus.INFO,
  0: AlertStatus.OK,
  // [-1]: AlertStatus.NO_DATA,  // TODO: Add support for "No Data" status
};

export const AlertStatusToScore: Record<AlertStatus, number> = {
  [AlertStatus.CRITICAL]: 5,
  [AlertStatus.TRIPPED]: 3,
  [AlertStatus.WARNING]: 3,
  [AlertStatus.INFO]: 1,
  [AlertStatus.OK]: 0,
  // [AlertStatus.NO_DATA]: -1,  // TODO: Add support for "No Data" status
};
